// extracted by mini-css-extract-plugin
export default {"font":"MainContent_font__S60t4","cross":"MainContent_cross__2nSFz","plus":"MainContent_plus__fPVR1"};